export class DeliveryDTO {
  sku:any;
  trnId:any;
}
